export default class Cards {
  constructor() {
    this._cards = document.querySelectorAll('.c-list-card')

    if (this._cards.length) {
      this.init();
    }
  }

  init() {
    this._cards.forEach(card => {
      let heightContent = 0;
      const content = card.querySelector('.c-text');
      const title = card.querySelector('.c-title');

      if (content) {
        heightContent = content.offsetHeight;
      }

      card.addEventListener('mouseover', () => {
        title.style.transform = 'translateY(-' + (heightContent / 2) + 'px)';
        content.style.transform = 'translateY(30px)';
      })

      card.addEventListener('mouseleave', () => {
        title.style.transform = 'translateY(0px)';
        content.style.transform = 'translateY(0px)';
      })

      card.addEventListener('touchstart', () => {
        title.style.transform = 'translateY(-' + (heightContent / 2) + 'px)';
        content.style.transform = 'translateY(30px)';
      })
    })
  }
}
